module.exports = __webpack_public_path__ + "img/1.596b6064.jpg";